import { mimicTypeIdSchema } from '@eigtech/typeid';
export const MeetingIdSchema = mimicTypeIdSchema('meeting');
